import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import Reckoner from "./reckoner/page/ReadyReckoner";
import MainNavigation from "./Navigation/MainNavigation";

const App = () => {
  return (
    <Router>
      <MainNavigation />
      <main>
        <Route path="/" exact component={Reckoner} />
      </main>
    </Router>
  );
};

export default App;
